import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styles from '../Base.module.css';
import './HtmlEditor.css';
import editorStyles from './HtmlEditor.module.css';
import ImageCompress from 'quill-image-compress';
Quill.register('modules/imageCompress', ImageCompress);
var CustomToolbar = function () { return (React.createElement("div", { id: 'toolbar', className: editorStyles.toolbar },
    React.createElement("button", { className: 'ql-bold' }),
    React.createElement("button", { className: 'ql-italic' }),
    React.createElement("button", { className: 'ql-underline' }),
    React.createElement("button", { className: 'ql-script', value: 'sub' }),
    React.createElement("button", { className: 'ql-script', value: 'super' }),
    React.createElement("select", { className: 'ql-color' }),
    React.createElement("button", { className: 'ql-link' }),
    React.createElement("button", { className: 'ql-list', value: 'ordered' }),
    React.createElement("button", { className: 'ql-list', value: 'bullet' }),
    React.createElement("button", { className: 'ql-image' }),
    React.createElement("button", { className: 'ql-clean' }))); };
var modules = {
    toolbar: {
        container: '#toolbar',
        handlers: {
            symbols: function (value) {
                if (value) {
                    var cursorPosition = this.quill.getSelection().index;
                    this.quill.insertText(cursorPosition, value);
                    this.quill.setSelection(cursorPosition + value.length);
                }
            }
        }
    },
    imageCompress: {
        quality: 0.75,
        maxWidth: 1000,
        maxHeight: 600,
        imageType: 'image/jpeg'
    }
};
var formats = [
    'bold',
    'italic',
    'underline',
    'list',
    'bullet',
    'link',
    'color',
    'script',
    'image'
];
var theme = 'snow';
export function hasText(value) {
    return value.length > 0 && value !== '<p><br></p>';
}
export function validateEditorState(value) {
    return hasText(value) ? undefined : 'Не должно быть пустым';
}
function HtmlEditor(props, ref) {
    var _a;
    var editorRef = useRef(null);
    var handleClick = function (event) {
        if (event.target) {
            var tooltip = event.target.closest('.ql-tooltip');
            if (tooltip) {
                return event.stopPropagation();
            }
        }
        editorRef.current.focus();
    };
    var setValue = props.setValue;
    var handleChange = useCallback(function (value) { return setValue(value); }, [setValue]);
    var inputClassName = classNames(styles.controlInput, editorStyles.wrapper, (_a = {},
        _a[styles.controlInputInvalid] = props.isValid === false,
        _a));
    return (React.createElement("div", { className: styles.control, ref: ref },
        props.label && (React.createElement("label", { className: styles.label },
            props.label,
            props.required && React.createElement("sup", { className: styles.requiredMark }, "*"))),
        React.createElement("div", { className: styles.inputContainer, onClick: handleClick },
            React.createElement(CustomToolbar, null),
            React.createElement(ReactQuill, { ref: editorRef, theme: theme, defaultValue: props.initialValue, onChange: handleChange, placeholder: props.placeholder, className: inputClassName, modules: modules, formats: formats, onFocus: props.onFocus, readOnly: props.disabled }),
            props.isValid === false && (React.createElement("div", { className: styles.validationMessage }, props.validationMessage)))));
}
export default React.memo(React.forwardRef(HtmlEditor), areEqual);
function areEqual(prevProps, nextProps) {
    var dirtyProps = [
        'setValue',
        'label',
        'placeholder',
        'required',
        'isValid',
        'onFocus',
        'disabled'
    ];
    return dirtyProps.every(function (key) { return prevProps[key] === nextProps[key]; });
}
